export enum DelayType {
    CALENDAR = 1,
    BUSINESS = 2,
}
